
enum GroupType
{
	mandatoryMultipleChoice = "Mandatory Multiple Choice",
	mandatorySingleChoice = "Mandatory Single Choice",
	optionalMultipleChoice = "Optional Multiple Choice",
	optionalSingleChoice = "Optional Single Choice"
}

export default GroupType
